import { render, staticRenderFns } from "./RegisterRole.vue?vue&type=template&id=6cbe68e4&scoped=true"
import script from "./RegisterRole.vue?vue&type=script&lang=js"
export * from "./RegisterRole.vue?vue&type=script&lang=js"
import style0 from "./RegisterRole.vue?vue&type=style&index=0&id=6cbe68e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe68e4",
  null
  
)

export default component.exports